import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#D8FFFF"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M92.047 94.895a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M104.547 26.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#0597A3" d="M7.318 60.86a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M30.97 91.117a1.5 1.5 0 0 1 0 2.121l-9.994 9.993a1.5 1.5 0 1 1-2.122-2.121l9.994-9.993a1.5 1.5 0 0 1 2.122 0"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M18.854 91.117a1.5 1.5 0 0 1 2.122 0l9.994 9.993a1.5 1.5 0 1 1-2.122 2.121l-9.994-9.993a1.5 1.5 0 0 1 0-2.12M44.566 0a1.5 1.5 0 0 1 1.5 1.5v14.134a1.5 1.5 0 0 1-3 0V1.5a1.5 1.5 0 0 1 1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M36 8.567a1.5 1.5 0 0 1 1.5-1.5h14.133a1.5 1.5 0 0 1 0 3H37.5a1.5 1.5 0 0 1-1.5-1.5"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      d="M49.92 26H22.467C20 26 18 28.073 18 30.631v50.247c0 2.558 2 4.632 4.466 4.632h27.455c2.025 0 3.862.78 5.27 2.06l.766.793 1.25 1.296c.22.228.506.341.794.341V34.377C58 29.75 54.383 26 49.92 26"
    />
    <path
      fill="#0597A3"
      d="M93.46 26H66.08C61.616 26 58 29.75 58 34.378V90c.287 0 .574-.113.794-.341l1.247-1.294.769-.797c1.408-1.278 3.244-2.058 5.27-2.058h27.38c2.507 0 4.54-2.108 4.54-4.709V30.708c0-2.6-2.033-4.708-4.54-4.708"
    />
    <path
      fill="#D8FFFF"
      d="M47.891 33.364H25.767c-1.12 0-2.028.908-2.028 2.028v15.67c0 1.12.908 2.027 2.028 2.027h22.124c1.12 0 2.028-.908 2.028-2.028V35.392c0-1.12-.908-2.028-2.028-2.028"
    />
    <path
      fill="#D8FFFF"
      fillRule="evenodd"
      d="M22.229 62.188a2.25 2.25 0 0 1 2.25-2.25H48.44a2.25 2.25 0 0 1 0 4.5H24.479a2.25 2.25 0 0 1-2.25-2.25M22.229 74.558a2.25 2.25 0 0 1 2.25-2.25H48.44a2.25 2.25 0 0 1 0 4.5H24.479a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
    <path
      fill="#00D8D8"
      fillRule="evenodd"
      d="M63.808 62.188a2.25 2.25 0 0 1 2.25-2.25H90.02a2.25 2.25 0 0 1 0 4.5H66.058a2.25 2.25 0 0 1-2.25-2.25M63.808 74.558a2.25 2.25 0 0 1 2.25-2.25H90.02a2.25 2.25 0 0 1 0 4.5H66.058a2.25 2.25 0 0 1-2.25-2.25M63.808 37.042a2.25 2.25 0 0 1 2.25-2.25H90.02a2.25 2.25 0 0 1 0 4.5H66.058a2.25 2.25 0 0 1-2.25-2.25M63.808 49.411a2.25 2.25 0 0 1 2.25-2.25H90.02a2.25 2.25 0 0 1 0 4.5H66.058a2.25 2.25 0 0 1-2.25-2.25"
      clipRule="evenodd"
    />
  </svg>
);
const SvgEnrichedIconCatalogInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconCatalogInverted);
export default Memo;
